import Modal from "../../shared/Modal";
import Button from "../../shared/Button";
import { capitalizeFirstLetter } from "../../utils";

const UserActivateModal = ({ visible, setVisible, submit, loading, type }) => {
  function handleCancelModal() {
    setVisible(false);
  }

  const modalFooter = (
    <>
      <Button onClick={handleCancelModal} type="alternative">
        Cancel
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        onClick={submit}
        type="primary"
      >
        Confirm
      </Button>
    </>
  );

  const modalContent = (
    <div className="space-y-4 text-center">
      <p className="text-lg font-medium">
        Are you sure you want to {type} this user?
      </p>
      {type === "activate" && (
        <p className="text-gray-600">
          An activation email will be automatically sent to their account
        </p>
      )}
    </div>
  );

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      onClose={() => setVisible(false)}
      title={`${capitalizeFirstLetter(type)} User`}
      footer={modalFooter}
      content={modalContent}
      size="md"
      footerPosition="right"
    />
  );
};

export default UserActivateModal;
